var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"title"},[_vm._v("404")]),_c('div',{staticClass:"message"},[_vm._v("Такой страницы не существует!")]),_c('b-button',{staticClass:"back",attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" Назад ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }